class DatePicker {
    init() {
        $.fn.datepicker.defaults.language = I18n.currentLocale();
        $.fn.datepicker.defaults.format = 'dd/mm/yyyy';
        $.fn.datepicker.defaults.disableDblClickSelection = true;
        $.fn.datepicker.defaults.autoclose = true;
        $.fn.datepicker.defaults.todayHighlight = true;
        $.fn.datepicker.defaults.daysOfWeekHighlighted = [0, 6];
        $.fn.datepicker.defaults.maxViewMode = 2;
        $.fn.datepicker.defaults.orientation = 'bottom';
        $('.datepicker').datepicker().on('changeDate', function (e) {
            $(e.target).change().focusout();
            $(e.target).find('input').change().focusout();
        });
    }
}

$(document).on('turbolinks:load', function () {
    (new DatePicker).init();
});

